export enum QuestionPickerResult {
  UseCached = 'cached',
  UseFresh = 'fresh',
}
